import { IUpcomingDatas } from '.';

export const inProgress: IUpcomingDatas[] = [
  {
    status: 'inprogress',
    progress: 60,
    imageURL: '',
    en: {
      title: 'Support Margin Trading with up to 5x leverage on Ultorex',
      content: `Are you a confident trader?

#Ultorex now supports margin trading with up to 5x leverage!!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support Margin Trading with up to 5x leverage on Ultorex',
      content: `Are you a confident trader?

#Ultorex now supports margin trading with up to 5x leverage!!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support Margin Trading with up to 5x leverage on Ultorex',
      content: `Are you a confident trader?

#Ultorex now supports margin trading with up to 5x leverage!!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'inprogress',
    progress: 5,
    imageURL: '',
    en: {
      title: 'Support Futures Trading on Ultorex',
      content: `Are you a confident trader?
      
#Ultorex now supports Futures trading!!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support Futures Trading on Ultorex',
      content: `Are you a confident trader?
      
#Ultorex now supports Futures trading!!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support Futures Trading on Ultorex',
      content: `Are you a confident trader?
      
#Ultorex now supports Futures trading!!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'inprogress',
    progress: 60,
    imageURL: '',
    en: {
      title: 'Multi-Language',
      content: `Ultorex now supports multiple languages with a click of a button!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Multi-Language',
      content: `Ultorex now supports multiple languages with a click of a button!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Multi-Language',
      content: `Ultorex now supports multiple languages with a click of a button!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'inprogress',
    progress: 5,
    imageURL: '',
    en: {
      title: 'Support OTC Trading on Ultorex',
      content: `Do you want to buy/sell coins in a more flexible, secured and cost efficient way?

#Ultorex will support OTC trading for all coins in exchange for USD and USDT.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support OTC Trading on Ultorex',
      content: `Do you want to buy/sell coins in a more flexible, secured and cost efficient way?

#Ultorex will support OTC trading for all coins in exchange for USD and USDT.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support OTC Trading on Ultorex',
      content: `Do you want to buy/sell coins in a more flexible, secured and cost efficient way?
      
#Ultorex will support OTC trading for all coins in exchange for USD and USDT.`,
      learnMoreUrl: '#',
    },
  },
];
